import AdsSvg from '../media/hexagonIconImage/icons/ads.svg';
import LowLatencyScg from '../media/hexagonIconImage/icons/cmaf_low_latency.svg';
import CustomizableUiSvg from '../media/hexagonIconImage/icons/customizable_ui.svg';
import DrmSvg from '../media/hexagonIconImage/icons/drm.svg';
import MobileSdksSvg from '../media/hexagonIconImage/icons/mobile_sdks.svg';
import ModularPlayerSvg from '../media/hexagonIconImage/icons/modular_player.svg';
import ServerSideAdInsertionSvg from '../media/hexagonIconImage/icons/server_side_ad_insertion.svg';

import HardcodedSalesDemoPath from './hardcodedSalesDemoPath';

export interface IPlayerNoteworthyFeature {
  readonly name: string;
  readonly description?: string;
  readonly iconPath: string;
  readonly salesDemoPath: HardcodedSalesDemoPath;
}

const PlayerNoteworthyFeatureData: ReadonlyArray<IPlayerNoteworthyFeature> = [
  {
    name: 'DRM support for Hollywood content',
    iconPath: DrmSvg,
    salesDemoPath: HardcodedSalesDemoPath.Drm
  },
  {
    name: 'Fully featured ad support',
    iconPath: AdsSvg,
    salesDemoPath: HardcodedSalesDemoPath.Ads
  },
  {
    name: 'Low Latency Streaming',
    iconPath: LowLatencyScg,
    salesDemoPath: HardcodedSalesDemoPath.LowLatencyStreaming
  },
  {
    name: 'Native player for Android, iOS, Android TV, tvOS and Fire OS',
    iconPath: MobileSdksSvg,
    salesDemoPath: HardcodedSalesDemoPath.NativeSdks
  },
  {
    name: 'Get past ad blocking software with SSAI',
    iconPath: ServerSideAdInsertionSvg,
    salesDemoPath: HardcodedSalesDemoPath.Ssai
  },
  {
    name: 'Modular Player',
    iconPath: ModularPlayerSvg,
    salesDemoPath: HardcodedSalesDemoPath.ModularPlayer
  },
  {
    name: 'Customizable UI',
    iconPath: CustomizableUiSvg,
    salesDemoPath: HardcodedSalesDemoPath.CustomizableUi
  }
];

export default PlayerNoteworthyFeatureData;
